var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBgBlur({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1443,
    height: 1099,
    viewBox: "0 0 1443 1099",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1424 853.356C1424 935.133 1293 892.14 1252.85 957.641C1231.3 992.801 1064.04 951.368 1033.57 979.267C952.87 1053.14 844.137 1098.41 724.521 1098.41C593.636 1098.41 209.833 1044.2 127.483 957.641C53.1958 879.554 373.352 824.335 373.352 709.611C373.352 609.625 -52.6023 110.241 5.43436 36.5183C87.808 -68.1185 578.468 175.503 724.521 175.503C814.133 175.503 884.251 106.249 954.434 150.055C985.46 169.419 1412.8 -23.544 1438 2.40577C1484.58 50.3797 1145.81 326.099 1166.4 390.684C1179.47 431.687 1424 808.179 1424 853.356Z",
    fill: "url(#paint0_linear_67_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_2",
    x1: -0.00000562245,
    y1: 213.189,
    x2: 1486.12,
    y2: 683.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E3426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBgBlur);
export default __webpack_public_path__ + "static/media/main_bg_blur.eb27447b05cbe9ff7299383c00c4ba77.svg";
export { ForwardRef as ReactComponent };